module.exports = __webpack_public_path__ + "assets/img/2008.e0df4b51.svg";